// src/pages/NotFound.jsx
import React from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { BiHome, BiArrowBack, BiErrorCircle } from "react-icons/bi";

const NotFound = () => {
  const { t, i18n } = useTranslation("global");
  const navigate = useNavigate();
  const isRTL = i18n.language === "ar";

  return (
    <div className="not-found-container ">
      <div className="not-found-wrapper">
        <div className="not-found-content">
          <div className="not-found-illustration">
            <div className="error-code">
              <span className="error-digit">4</span>
              <span className="error-digit middle">0</span>
              <span className="error-digit">4</span>
            </div>
            <div className="error-icon-wrapper">
              <BiErrorCircle className="error-icon" />
            </div>
          </div>

          <div className="not-found-text">
            <h1 className="not-found-title">
              {t("not_found_title") || "Page Not Found"}
            </h1>
            <p className="not-found-message">
              {t("not_found_message") || 
                "Oops! The page you're looking for doesn't exist or has been moved."}
            </p>
          </div>

          <div className="not-found-actions">
            <Link 
              to="/" 
              className="btn-not-found btn-primary-not-found"
            >
              {isRTL ? (
                <>
                  <BiArrowBack className="btn-icon" />
                  <span>{t("sidenav.home") || "Home"}</span>
                </>
              ) : (
                <>
                  <span>{t("sidenav.home") || "Home"}</span>
                  <BiHome className="btn-icon" />
                </>
              )}
            </Link>
            <button 
              onClick={() => navigate(-1)} 
              className="btn-not-found btn-secondary-not-found"
            >
              {isRTL ? (
                <>
                  <BiArrowBack className="btn-icon" />
                  <span>{i18n.language === "ar" ? "العودة" : "Go Back"}</span>
                </>
              ) : (
                <>
                  <BiArrowBack className="btn-icon rotate" />
                  <span>{i18n.language === "ar" ? "العودة" : "Go Back"}</span>
                </>
              )}
            </button>
          </div>
        </div>

        <div className="not-found-decoration">
          <div className="decoration-circle circle-1"></div>
          <div className="decoration-circle circle-2"></div>
          <div className="decoration-circle circle-3"></div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
